import React from "react";
import { DocsIcon64Regular } from "@skbkontur/icons/DocsIcon64Regular";

import { Children, Description, IconBlock, Root, Title } from "./EmptyTemplate.styles";

interface EmptyTemplateProps {
    title?: string;
    description?: string | React.ReactNode;
    width?: number;
    children?: React.ReactNode;
}

/*
 * После поднятия react-ui >= 5, использовать готовый компонент
 * https://tech.skbkontur.ru/kontur-ui/?path=/docs/empty-state_emptystate--docs
 * */

export const EmptyTemplate = ({ title, description, children, width }: EmptyTemplateProps) => (
    <Root width={width}>
        <IconBlock>
            <DocsIcon64Regular color="#757575" />
        </IconBlock>
        {title && <Title>{title}</Title>}
        {description && <Description>{description}</Description>}
        {children && <Children>{children}</Children>}
    </Root>
);
